<template>
  <input
    :placeholder="placeholder"
    :type="type"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  name: "VInput",
  props: {
    placeholder: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data: () => ({
    value: ""
  })
};
</script>

<style lang="scss" scoped>
input {
  margin: 10px;
  overflow: visible;
  padding: 10px;
  width: 100%;
}
</style>
